<template>
  <div>
    <b-card sub-title="Vaccination Details (Dose Number, ,Vaccine Name, Date)">
      <div v-for="(v, index) in $v.treatments.$each.$iter" :key="index">
        <hr v-if="index > 0" class="treatments-row"/>
        <b-row >
          <b-col lg="4">
            <b-form-input readonly type="text" class="form-control" id="dose" v-model="v.dose.$model"  min=1 max=2 :state="chkState('dose', index)"  placeholder="Dose Number" inline></b-form-input>
          </b-col>
          <b-col lg="4">
          <b-form-select  ref="vtype" id="vtype" name="vtype" :class="{ danger: v.vtype.$error }" @search:blur="v.vtype.$touch()" :state="chkState('vtype', index)"  :options="vTypesList"  v-model="v.vtype.$model"  value-field="id" text-field="name"></b-form-select>
          </b-col>
          <b-col lg="4">
            <b-form-datepicker :max="max" :id="`date-${index}`" :ref="`date-${index}`" v-model="v.date.$model" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :state="chkState('date', index)" > </b-form-datepicker>

          </b-col>
        </b-row>
      </div>
    </b-card>

    <div class="alert alert-danger" v-if="!$v.treatments.required && $v.treatments.$dirty">Please provide at least one Vaccination Detail</div>
  </div>

</template>

<script>
import Vue from 'vue'

import {
  required
} from "vuelidate/lib/validators"
import moment from 'moment'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'VaccinationList',

  computed: {
    isValid() {
      return !this.$v.treatments.$anyError
    },
    isDirty() {
      return this.$v.treatments.$anyDirty
    }
  },
  data: function () {
    return {

      treatments: [],
      max: new Date(),
    };
  },
  validations: {
    treatments: {
      required,
      $each: {
        vtype: {
          required,
        },
        dose: {
          required
        },
        date: {
          required
        }
      }
    }
  },
  computed: {
    total(){
      return this.treatments.length;
    },
    vTypesList() {
      return map(this.$store.state.vims.vaccineTypes, (type) => {
      return {
        name: type.name,
        id: type.id
      }
      })
    },
  },
  methods: {

    addTreatment() {
      this.treatments.push({dose: this.treatments.length + 1, vtype: "", date: null, id: ""})
      let params = this.getTreatments();
      this.$emit('doseAdded', params);
    },
    removeTreatment() {
      this.treatments.pop();
      let params = this.getTreatments();
      this.$emit('doseAdded', params);
    },
    getSize(){
      return 0;
    },
    getTreatments() {


      let doses = {};
      this.treatments.forEach((element, index, array) => {
        doses['dose' + (index+1)] = element;

      });



      return doses;
    },
    setTreatment(treatment) {
      this.treatments.push({dose: treatment.dose, vtype: treatment.vtypeid, date: treatment.date,id: treatment.id});
      let params = this.getTreatments();
      this.$emit('doseAdded', params);
    },
    onReset() {
      this.treatments = []
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val, index) {
      const field = this.$v.treatments.$each[index][val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  created() {
      this.treatments = []
  },
}
</script>

<style>
.treatments-row {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
